import { gql } from '@apollo/client'

export const RECEIVED_EMAILS_QUERY = gql`
  query receivedEmails(
    $page: Int
    $limit: Int
    $filter: ReceivedEmailFilter
    $sortBy: ReceivedEmailSort
  ) {
    receivedEmails(page: $page, limit: $limit, filter: $filter, sortBy: $sortBy) {
      collection {
        id
        subject
        from
        to
        date
        processedAt
        error
        createdAt
        hermineRequests {
          id
          status
          updatedAt
        }
      }
      metadata {
        totalCount
        currentPage
      }
    }
  }
`
